import { Classes, Icon } from '@clarion-blueprint-shim';
import { ReactNode, SelectHTMLAttributes, useId } from 'react';
import { tv } from 'tailwind-variants';
import { ClarionLabel } from './ClarionLabel';

export interface ClarionHTMLSelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  description?: string;
  errorMessage?: string;
  fill?: boolean;
  minimal?: boolean;
  large?: boolean;
  iconProps?: any;
  options?: Array<{ label: string; value: string | number; disabled?: boolean }>;
  children?: ReactNode;
}

const selectStyles = tv({
  base: Classes.HTML_SELECT + ' forced-colors:border-1',
  variants: {
    isDisabled: {
      true: Classes.DISABLED,
    },
    fill: {
      true: Classes.FILL,
    },
    minimal: {
      true: Classes.MINIMAL,
    },
    large: {
      true: Classes.LARGE,
    },
  },
});

export function ClarionHTMLSelect({
  label,
  description,
  errorMessage,
  fill,
  minimal,
  large,
  iconProps,
  options,
  children,
  className,
  ...props
}: ClarionHTMLSelectProps) {
  const id = useId();
  return (
    <div className={`flex flex-col ${fill ? 'grow' : ''}`}>
      {label && <ClarionLabel htmlFor={props.id || id}>{label}</ClarionLabel>}
      <div className={selectStyles({ fill, minimal, large, className })}>
        <select id={props.id || id} {...props}>
          {options
            ? options.map((option) => (
                <option key={option.value} value={option.value} disabled={option.disabled}>
                  {option.label}
                </option>
              ))
            : children}
        </select>
        <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
          <Icon icon="chevron-down" className="text-gray-500" />
        </div>
      </div>
      {description && <div className="text-xs text-gray-600 dark:text-gray-400">{description}</div>}
      {errorMessage && <div className="text-xs text-red-600 dark:text-red-400">{errorMessage}</div>}
    </div>
  );
}
